import { Button as NSButton } from '@vodacomsa/ns-react-components';
import styled from 'styled-components';

export const Button = styled(NSButton)`
  display: inline-block;
  color: #fff;
  &[disabled] {
    color: #fff;
  }
`;
